import type { SxProps, Theme } from '@mui/material/styles'

/**
 * Shared dialog title + modal paper chrome using Environment CSS variables
 * (--sevv-dialog-title-*, palette vars). Set on :root via applySevvCssVariables.
 */

/** In-room game override first, then shell Appearance, then primary gradient. */
export const SEVV_DIALOG_TITLE_BACKGROUND =
  'var(--sevv-surface-game-dialog-title-bg, var(--sevv-dialog-title-bg, linear-gradient(135deg, var(--sevv-primary, #f97415) 0%, var(--sevv-primary-light, #ffa047) 100%)))'

/** Default border matches game/shell modals when admin override is unset. */
export const SEVV_DIALOG_TITLE_BORDER_BOTTOM =
  'var(--sevv-surface-game-dialog-title-border-bottom, var(--sevv-dialog-title-border-bottom, 1px solid color-mix(in srgb, var(--sevv-primary, #f97415) 30%, transparent)))'

export const SEVV_DIALOG_TITLE_COLOR =
  'var(--sevv-surface-game-dialog-title-color, var(--sevv-dialog-title-color, #ffffff))'

/** Muted line under the main title; derives from title text color for custom Appearance values. */
export const SEVV_DIALOG_TITLE_SUBTITLE_COLOR =
  'color-mix(in srgb, var(--sevv-dialog-title-color, #ffffff) 92%, transparent)'

export const sevvDialogTitleChromeSx: SxProps<Theme> = {
  background: SEVV_DIALOG_TITLE_BACKGROUND,
  borderBottom: SEVV_DIALOG_TITLE_BORDER_BOTTOM,
  color: SEVV_DIALOG_TITLE_COLOR,
  '& .MuiTypography-root': { color: 'inherit' },
  '& .MuiSvgIcon-root': { color: 'inherit' },
}

/** Workspace primary for MUI `sx` / inline styles (tabs, links, spinners). */
export const SEVV_PRIMARY_CSS = 'var(--sevv-primary, #f97415)'

export const SEVV_PRIMARY_LIGHT_CSS = 'var(--sevv-primary-light, #ffa047)'

/** Vertical brand strip (e.g. release cards). */
export const SEVV_PRIMARY_GRADIENT_VERTICAL = `linear-gradient(180deg, ${SEVV_PRIMARY_CSS}, ${SEVV_PRIMARY_LIGHT_CSS})`

/**
 * Product-style dialog paper: pale brand wash at top fading to paper (tokens only).
 */
export const SEVV_DIALOG_PAPER_BACKGROUND_PALE_TOP =
  'linear-gradient(180deg, var(--sevv-primary-pale, #fff2d6) 0%, var(--sevv-bg-paper, #ffffff) 18%, var(--sevv-bg-paper, #ffffff) 100%)'

export const SEVV_DIALOG_PAPER_BORDER =
  '1px solid var(--sevv-surface-game-toolbar-border, color-mix(in srgb, var(--sevv-primary, #f97415) 20%, transparent))'

/** Flat shell border (aligned with MUI `divider`); use with solid paper. */
export const SEVV_DIALOG_PAPER_BORDER_DIVIDER = '1px solid var(--sevv-divider)'

/** Solid modal body; avoids warm diagonal gradient on dark paper. */
export const SEVV_DIALOG_PAPER_BACKGROUND_SOLID = 'var(--sevv-bg-paper)'

export const SEVV_DIALOG_PAPER_SHADOW =
  '0 25px 50px -12px rgba(0, 0, 0, 0.25), var(--sevv-shadow-primary, 0 4px 14px 0 rgba(249, 116, 21, 0.3))'
